export default __webpack_public_path__ + "static/GEAwtarDWTC-Medium-5e403240fa2542e72f9f525315c5fb97.woff";